import StockAdjustment from "../pages/stockReports/stockAdjustment";
import StockRegister from "../pages/stockReports/stockRegister";
import Dashboard from "../pages/dashboard/Dashboard";
import CompanyMaster from "../pages/masetrEntry/companyMaster/CompanyMaster";
import PartyAccountMaster from "../pages/masetrEntry/partyAccountMaster/PartyAccountMaster";
import PendingWoReport from "../pages/transactionReports/pendingWoReport";
import PendingWorkOrderItem from "../pages/transactionReports/pendingWorkOrderItem";
import ItemWisePendingReport from "../pages/transactionReports/ItemWisePendingReport";
import PartyWisePendingReport from "../pages/transactionReports/PartyWisePendingReport";
import MinMaxStockRegisterLevel from "../pages/stockReports/minMaxStockRegisterLevel";
import ItemGroupDetailReport from "../pages/stockReports/itemGroupDetailReport";
import ItemGroupStockCategoryWiseDetailsReport from "../pages/stockReports/itemGroupStockCategoryWiseDetailsReport";
import ItemWiseStockDetailReport from "../pages/stockReports/itemWiseStockDetailReport";
import GeneralPurchaseRegister from "../pages/stockReports/generalPurchaseRegister";
import SalesGeneralRegister from "../pages/stockReports/salesGeneralRegister";
import AccountStockReport from "../pages/stockReports/accountStockReport";
import UserReports from "../pages/stockReports/userReports";
import PaymentVoucher from "../pages/accountTransaction/paymentVoucher/PaymentVoucher";
import PaymentReceive from "../pages/accountTransaction/paymentReceive/PaymentReceive";
import BankLedgerAccount from "../pages/accountTransaction/bankLedgerAccount/BankLedgerAccount";
import GeneralPurchase from "../pages/accountTransaction/generalPurchase/GeneralPurchase";
import AdvanceWithdraw from "../pages/accountTransaction/advanceWithdraw/AdvanceWithdraw";
import EmployeeSalary from "../pages/accountTransaction/employeeSalary/EmployeeSalary";
import AddCashAdvance from "../pages/accountTransaction/addCashAdvance/AddCashAdvance";
import SalaryToBankTransfer from "../pages/accountTransaction/salaryToBankTransfer/SalaryToBankTransfer";
import BankToBankTransfer from "../pages/accountTransaction/bankToBankTransfer/BankToBankTransfer";
import JournalVoucher from "../pages/accountTransaction/journalVoucher/JournalVoucher";
import TdsEntry from "../pages/accountTransaction/tdsEntry/TdsEntry";
import CreditNoteEntry from "../pages/accountTransaction/creditNoteEntry/CreditNoteEntry";
import DebitNoteEntry from "../pages/accountTransaction/debitNoteEntry/DebitNoteEntry";
import UnAuthorized from "../pages/authentication/UnAuthorized";
import BankMaster from "../pages/accountMaster/bankMaster/BankMaster";
import EmployeeMaster from "../pages/masetrEntry/employeeMaster/EmployeeMaster";
import AccountGroup from "../pages/accountMaster/accountGroup/AccountGroup";
import AccountHeadMaster from "../pages/accountMaster/accountHeadMaster/AccountHeadMaster";
import GeneralAccountHead from "../pages/accountMaster/generalAccountHead/GeneralAccountHead";
import LedgerReport from "../pages/accountReports/ledgerReport/LedgerReport";
import ProfitLossReport from "../pages/accountReports/profitLossReport/ProfitLossReport";
import BalanceSheet from "../pages/accountReports/balanceSheet/BalanceSheet";
import CountryMaster from "../pages/accountMaster/countryMaster/CountryMaster";
import StateMaster from "../pages/accountMaster/stateMaster/StateMaster";
import CityMaster from "../pages/accountMaster/cityMaster/CityMaster";
import TaxStructureMaster from "../pages/masetrEntry/taxStructureMaster/TaxStructureMaster";
import DesignationMaster from "../pages/masetrEntry/designationMaster/DesignationMaster";
import DepartmentMaster from "../pages/masetrEntry/departmentMaster/DepartmentMaster";
import EmployeeGroup from "../pages/masetrEntry/employeeGroup/EmployeeGroup";
import UnitMaster from "../pages/masetrEntry/unitMaster/UnitMaster";
import ProductSizeMaster from "../pages/masetrEntry/productSizeMaster/ProductSizeMaster";
import MaterialMaster from "../pages/masetrEntry/materialMaster/MaterialMaster";
import PaymentModeMaster from "../pages/masetrEntry/paymentModeMaster/PaymentModeMaster";
import PlantMaster from "../pages/masetrEntry/plantMaster/PlantMaster";
import ProcessMaster from "../pages/masetrEntry/processMaster/ProcessMaster";
import ItemCategoryMaster from "../pages/masetrEntry/itemCategoryMaster/ItemCategoryMaster";
import ItemGroup from "../pages/masetrEntry/itemGroup/ItemGroup";
import ItemMaster from "../pages/masetrEntry/itemMaster/ItemMaster";
import EmployeeRecordPlantWise from "../pages/masetrEntry/employeeRecordPlantWise/EmployeeRecordPlantWise";
import ItemWiseProcess from "../pages/masetrEntry/itemWiseProcess/ItemWiseProcess";
import ItemRateVendorWise from "../pages/masetrEntry/itemRateVendorWise/ItemRateVendorWise";
import ProductBOMSetup from "../pages/masetrEntry/productBOMSetup/ProductBOMSetup";
import PlantWiseItem from "../pages/masetrEntry/plantWiseItem/PlantWiseItem";
import ChequeBookMaster from "../pages/accountMaster/chequeBookMaster/ChequeBookMaster";
import OpeningStock from "../pages/masetrEntry/openingStock/OpeningStock";
import ProcessRatesItemWise from "../pages/masetrEntry/processRates/ProcessRates";
import ManuallyInvoice from "../pages/otherForms/manuallyInvoice/ManuallyInvoice";
import MaterialOut from "../pages/otherForms/materialOut/MaterialOut";
import MaterialIn from "../pages/otherForms/materialIn/MaterialIn";
import GatePass from "../pages/otherForms/gatePass/GatePass";
import WoOrderReceive from "../pages/transaction/woOrderReceive/WoOrderReceive";
import MaterialPlaning from "../pages/transaction/materialPlaning/MaterialPlaning";
import DisAssembleTransaction from "../pages/otherForms/disAssembleTransaction/DisAssembleTransaction";
import StockTransfer from "../pages/otherForms/stockTransfer/StockTransfer";
import EmployeeProblem from "../pages/otherForms/employeeProblem/EmployeeProblem";
import JwOut from "../pages/otherForms/jwOut/JwOut";
import SalesInvoice from "../pages/transaction/salesInvoice/SalesInvoice";
import DeliveryChallan from "../pages/transaction/deliveryChallan/DeliveryChallan";
import MaterialJobWork from "../pages/transaction/materialJobWork/MaterialJobWork";
import JobWorkInward from "../pages/transaction/jobWorkInward/JobWorkInward";
import PurchaseOrder from "../pages/transaction/purchaseOrder/PurchaseOrder";
import MaterialPurchase from "../pages/transaction/materialPurchase/MaterialPurchase";
import ProductBOMReports from "../pages/masterReports/productBOMReports/ProductBOMReports";
import BOMSetupReports from "../pages/masterReports/bomSetupReport/BOMSetupReport";
import BOMForm from "../pages/masterReports/bomForm/BOMForm";
import StoreStockReport from "../pages/masterReports/storeStockReport/StoreStockReport";
import ProductionDashboard from "../pages/masterReports/productionDashboard/ProductionDashboard";
import MaterialTesting from "../pages/transaction/materialTesting/MaterialTesting";
import CalculatePlanning from "../pages/transaction/calculatePlanning/CalculatePlanning";
import PurchaseInquiry from "../pages/transaction/purchaseInquiry/PurchaseInquiry";
import PurchaseInquiryOutward from "../pages/transaction/purchaseInquiryOutward/PurchaseInquiryOutward";
import WorkPlanning from "../pages/transaction/workPlanning/WorkPlanning";
import MaterialRejection from "../pages/transaction/materialRejection/MaterialRejection";
import MaterialRejectionOutward from "../pages/transaction/materialRejectionOutward/MaterialRejectionOutward";
import SalesReturn from "../pages/transaction/salesRetun/SalesReturn";
import MaterialIssue from "../pages/transaction/materialIssue/MaterialIssue";
import StoreToPlant from "../pages/otherForms/storeToPlant/StoreToPlant";
import BackToStore from "../pages/otherForms/backToStore/BackToStore";
import MaterialProduction from "../pages/transaction/materialProduction/MaterialProduction";
import IssueProcessTransaction from "../pages/transaction/issueProcessTransaction/IssueProcessTransaction";
import EmployeeRecordProcessWise from "../pages/masetrEntry/employeeRecordProcessWise/EmployeeRecordProcessWise";
import AdminPermissions from "../pages/utility/adminPermissions/AdminPermissions";
import HodPermissions from "../pages/utility/hodPermissions/HodPermissions";
import UserPermissions from "../pages/utility/userPermissions/UserPermissions";
import RolesAndAccess from "../pages/utility/rolesAndAccess/RolesAndAccess";
import RoleManagement from "../pages/utility/roleManagement/RoleManagement";
import ReworkProduct from "../pages/transaction/reworkProduct/ReworkProduct";
import SalesReturnToStore from "../pages/transaction/mrsRegister/SalesReturnToStore";
import ItemLedgerReport from "../pages/transactionReports/itemLedgerReport/ItemLedgerReport";
import AccountHeadSummary from "../pages/accountReports/accountHeadSummary/AccountHeadSummary";
import EmployeeSalaryReport from "../pages/stockReports/employeeSalaryReport";
// import Sidebar from "../shared/sidebar/Sidebar";

const ComponentNavigation = [
    // Un Authorized 
    {
        path: "authentication/UnAuthorized",
        previousPath: "UnAuthorized",
        title: "UnAuthorized",
        component: UnAuthorized,
        roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14],
        hasParams: false,
    },
    {
        path: "dashboard",
        title: "Dashboard",
        component: Dashboard,
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },

    /*---------- Daily reports start ----------*/
    {
        path: "stock-reports/stock-register",
        title: "Stock register",
        component: StockRegister,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/stock-adjustment",
        title: "Stock adjustment",
        component: StockAdjustment,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/item-wise-stock-detail-report",
        title: "Item wise stock detail report",
        component: ItemWiseStockDetailReport,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/min-max-stock-register-level",
        title: "Min/max stock register level",
        component: MinMaxStockRegisterLevel,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/account-stock-report",
        title: "Account stock report",
        component: AccountStockReport,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/item-group-detail-report",
        title: "Item group detail report",
        component: ItemGroupDetailReport,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/item-group-stock-category-wise-details-report",
        title: "Item group stock category wise details report",
        component: ItemGroupStockCategoryWiseDetailsReport,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/general-purchase-register",
        title: "General purchase register",
        component: GeneralPurchaseRegister,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/sales-general-register",
        title: "Sales general register",
        component: SalesGeneralRegister,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-reports/user-reports",
        title: "User reports",
        component: UserReports,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Daily reports end ----------*/

    /*---------- Account start ---------*/
    {
        path: "payment-voucher",
        title: "Payment voucher",
        component: PaymentVoucher,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "payment-receive",
        title: "Payment receive",
        component: PaymentReceive,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "bank-ledger-account",
        title: "Expense ledger account",
        component: BankLedgerAccount,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "general-purchsse",
        title: "General purchase",
        component: GeneralPurchase,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "advance-withdraw",
        title: "Advance withdraw",
        component: AdvanceWithdraw,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "employee-salary",
        title: "Employee salary",
        component: EmployeeSalary,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "add-cash",
        title: "Add cash/advance",
        component: AddCashAdvance,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "salary-to-bank-transfer",
        title: "Salary to bank transfer",
        component: SalaryToBankTransfer,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "bank-to-bank-transfer",
        title: "Bank to bank transfer",
        component: BankToBankTransfer,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "journal-voucher",
        title: "Journal voucher",
        component: JournalVoucher,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "tds-entry",
        title: "TDS entry",
        component: TdsEntry,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "credit-note-entry",
        title: "Credit note entry",
        component: CreditNoteEntry,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "debit-note-entry",
        title: "Debit note entry",
        component: DebitNoteEntry,
        previousPath: "Transaction account",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Account end ----------*/

    /*--------- Master start ----------*/
    {
        path: "company-master",
        title: "Company master",
        component: CompanyMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "party-account-master",
        title: "Party account master",
        component: PartyAccountMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "tax-structure",
        title: "Tax structure master",
        component: TaxStructureMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "designation",
        title: "Designation master",
        component: DesignationMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "department",
        title: "Department master",
        component: DepartmentMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "employee-group",
        title: "Employee group",
        component: EmployeeGroup,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "employee-master",
        title: "Employee master",
        component: EmployeeMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "employee-record",
        title: "Employee record plant wise",
        component: EmployeeRecordPlantWise,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "employee-record-process-wise",
        title: "Employee record process wise",
        component: EmployeeRecordProcessWise,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "unit-master",
        title: "Unit master",
        component: UnitMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "product-size-master",
        title: "Product size master",
        component: ProductSizeMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-master",
        title: "Material master",
        component: MaterialMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "payment-mode-master",
        title: "Payment mode master",
        component: PaymentModeMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "item-rate-vendor-wise",
        title: "Item rate vendor wise",
        component: ItemRateVendorWise,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "plant-master",
        title: "Plant master",
        component: PlantMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "process-master",
        title: "Process master",
        component: ProcessMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "item-categoty-master",
        title: "Item category master",
        component: ItemCategoryMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "item-group",
        title: "Item group",
        component: ItemGroup,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "item-master",
        title: "Item master",
        component: ItemMaster,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "product-bom-setup",
        title: "Product BOM setup",
        component: ProductBOMSetup,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "item-wise-process",
        title: "Item wise process",
        component: ItemWiseProcess,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "plant-wise-item",
        title: "Plant wise item",
        component: PlantWiseItem,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "opening-stock",
        title: "Opening stock",
        component: OpeningStock,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "process-rates",
        title: "Process rates item wise",
        component: ProcessRatesItemWise,
        previousPath: "Master entry",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Master end ----------*/

    /*---------- Account Master start ----------*/
    {
        path: "country-master",
        title: "Country master",
        component: CountryMaster,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "state-master",
        title: "State master",
        component: StateMaster,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "city-master",
        title: "City master",
        component: CityMaster,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "bank-master",
        title: "Bank master",
        component: BankMaster,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "account-group",
        title: "Account group",
        component: AccountGroup,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "account-head-master",
        title: "Account head master",
        component: AccountHeadMaster,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "general-account-head",
        title: "General account head",
        component: GeneralAccountHead,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "chequebook-master",
        title: "Cheque book master",
        component: ChequeBookMaster,
        previousPath: "Account master",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Account Master end ----------*/

    /*---------- Account report start ----------*/
    {
        path: "ledger-report",
        title: "Ledger report",
        component: LedgerReport,
        previousPath: "Account reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "account-head-summary",
        title: "Account Head Summary",
        component: AccountHeadSummary,
        previousPath: "Account reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "profit-loss-report",
        title: "Profit-loss report",
        component: ProfitLossReport,
        previousPath: "Account reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "balance-sheet",
        title: "Balance sheet",
        component: BalanceSheet,
        previousPath: "Account reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Account report end ----------*/

    /*---------- Other forms start ----------*/
    {
        path: "material-out",
        title: "Material out",
        component: MaterialOut,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-in",
        title: "Material in",
        component: MaterialIn,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "gatepass",
        title: "Gate pass",
        component: GatePass,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "disassemble-transaction",
        title: "Disassemble transaction",
        component: DisAssembleTransaction,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "manually-invoice",
        title: "Manually invoice",
        component: ManuallyInvoice,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "stock-transfer",
        title: "Stock transfer",
        component: StockTransfer,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "employee-problem",
        title: "Employee problem",
        component: EmployeeProblem,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "jw-out",
        title: "JW out",
        component: JwOut,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "store-to-plant",
        title: "Store to plant",
        component: StoreToPlant,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "back-to-store",
        title: "Back to store",
        component: BackToStore,
        previousPath: "Other forms",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Other forms end ----------*/

    /*---------- Transaction start ----------*/
    {
        path: "wo-receive",
        title: "WO order receive",
        component: WoOrderReceive,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-palning",
        title: "Material planning",
        component: MaterialPlaning,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "calculate-palning",
        title: "Calculate planning data",
        component: CalculatePlanning,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "sales-return-store",
        title: "Sales Return To Store",
        component: SalesReturnToStore,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "purchase-inquiry",
        title: "Purchasing inquiry",
        component: PurchaseInquiry,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "purchase-inquiry-outward",
        title: "Purchase inquiry outward",
        component: PurchaseInquiryOutward,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "work-planning",
        title: "Work planning",
        component: WorkPlanning,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "purchase-order",
        title: "Purchase order",
        component: PurchaseOrder,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-purchase",
        title: "Material purchase",
        component: MaterialPurchase,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-testing",
        title: "Material testing",
        component: MaterialTesting,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-rejection",
        title: "Material rejection",
        component: MaterialRejection,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-rejection-outward",
        title: "Material rejection outward",
        component: MaterialRejectionOutward,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "delivery-challan",
        title: "Delivery challan",
        component: DeliveryChallan,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "sales-invoice",
        title: "Sales invoice",
        component: SalesInvoice,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "sales-return",
        title: "Sales return",
        component: SalesReturn,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "rework-product",
        title: "Rework product",
        component: ReworkProduct,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-issue",
        title: "Material issue",
        component: MaterialIssue,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-production",
        title: "Material production",
        component: MaterialProduction,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "issue-process-transaction",
        title: "Issue process transaction",
        component: IssueProcessTransaction,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "material-job-work",
        title: "Material job work",
        component: MaterialJobWork,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "job-work-inward",
        title: "Job work inward",
        component: JobWorkInward,
        previousPath: "Transaction stock",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Transaction end ----------*/

    {
        path: "item-ledger-report",
        title: "Item Ledger Report",
        component: ItemLedgerReport,
        previousPath: "Transaction reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "item-wise-pending-report",
        title: "Item wise pending",
        component: ItemWisePendingReport,
        previousPath: "Transaction reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "party-wise-pending-report",
        title: "Party wise pending",
        component: PartyWisePendingReport,
        previousPath: "Transaction reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },

    {
        path: "employee-salary-report",
        title: "Employee Salary Report",
        component: EmployeeSalaryReport,
        previousPath: "Stock reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },

    /*---------- Master reports start ----------*/
    {
        path: "product-bom-reports",
        title: "Product BOM reports",
        component: ProductBOMReports,
        previousPath: "Master reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "bom-setup-reports",
        title: "BOM setup reports",
        component: BOMSetupReports,
        previousPath: "Master reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "bom-form",
        title: "BOM form",
        component: BOMForm,
        previousPath: "Master reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "store-stock-report",
        title: "Store stock report",
        component: StoreStockReport,
        previousPath: "Master reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "production-dashboard",
        title: "Production dashboard",
        component: ProductionDashboard,
        previousPath: "Master reports",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Master reports end ----------*/

    /*---------- Utility start ----------*/
    {
        path: "admin-permissions",
        title: "Admin Permissions",
        component: AdminPermissions,
        previousPath: "Utility",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "hod-permissions",
        title: "HOD Permissions",
        component: HodPermissions,
        previousPath: "Utility",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "user-permissions",
        title: "User Permissions",
        component: UserPermissions,
        previousPath: "Utility",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "role-access",
        title: "Roles And Access",
        component: RolesAndAccess,
        previousPath: "Utility",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "role-management",
        title: "Roles Management",
        component: RoleManagement,
        previousPath: "Utility",
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Utility end ----------*/

    {
        path: "pending-work-order-item/pending-wo-report",
        title: "Pending WO report",
        component: PendingWoReport,
        hasParams: false,
        isExpandable: false,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },


    /*---------- Pages for redirection start ----------*/
    {
        path: "pending-work-order-item",
        title: "Pending work order item",
        component: PendingWorkOrderItem,
        hasParams: false,
        isExpandable: true,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    {
        path: "Planningandproductionreports",
        title: "Planning and production reports",
        component: PendingWorkOrderItem,
        hasParams: false,
        isExpandable: true,
        roles: [1, 2, 3, 4, 5, 6, 7],
    },
    /*---------- Pages for redirection end ----------*/
];
export default ComponentNavigation;
